module.exports = __webpack_public_path__ + "img/kv_img_m.7becf029.webp";